/* eslint-disable */
import { call, put, takeLatest, select } from "redux-saga/effects";
import { replace, push } from "connected-react-router";

import { NO_TRANSITION } from "constants.js";
import * as accountsMiddleware from "middleware/accounts";
import { types, selectors } from "reducers/accounts";
import { actions as notificationActions } from "reducers/notification";
import { downloadPdf, downloadXls } from "util/download";
import { normalizeMovementsDates } from "util/date";
import { adjustIdFieldErrors } from "util/form.js";
import * as i18n from "util/i18n";
import { unifyListParams } from "util/account";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as formSelectors } from "reducers/form";
import { handleError } from "sagas";
import { credentialsErrorMessage } from "util/validateMessage";
import { downloadTxt } from "util/download";

import { store } from "store";

const sagas = [
    takeLatest(types.ACCOUNT_READ_REQUEST, accountRead),
    takeLatest(types.ACCOUNT_READ_QR_REQUEST, accountReadQr),
    takeLatest(types.ACCOUNT_DETAILS_REQUEST, accountDetails),
    takeLatest(types.ACCOUNT_DOWNLOAD_STATEMENT_REQUEST, downloadStatement),
    takeLatest(types.ACCOUNT_FETCH_MORE_MOVEMENTS_REQUEST, fetchMoreMovements),
    takeLatest(types.EDIT_MOVEMENT_NOTE_REQUEST, editMovementNote),
    takeLatest(types.LIST_ACCOUNT_STATEMENTS_REQUEST, listStatements),
    takeLatest(types.LIST_ACCOUNTS_REQUEST, listAccountsRequest),
    takeLatest(types.LIST_ALL_ACCOUNTS_REQUEST, listAllAccountsRequest),
    takeLatest(types.LIST_ACCOUNTS_CBU_REQUEST, listAccountsCbuRequest),
    takeLatest(types.DOWNLOAD_HISTORICAL_BALANCES_REQUEST, downloadHistoricalBalances),
    takeLatest(types.DOWNLOAD_MOVEMENTS_REQUEST, downloadMovements),
    takeLatest(types.DOWNLOAD_PENDING_MOVEMENTS_REQUEST, downloadPendingMovements),
    takeLatest(types.DOWNLOAD_ACCOUNTS_REQUEST, downloadAccounts),
    takeLatest(types.ACCOUNT_FETCH_MOVEMENTS_REQUEST, fetchMovements),
    takeLatest(types.ACCOUNT_FETCH_MOVEMENTS_STATES_REQUEST, fetchMovementsState),
    takeLatest(types.ACCOUNT_GET_YEARS_MONTH_SUMMARY_REQUEST, accountGetYearMonth),
    takeLatest(types.ACCOUNT_AGREEMENTS_REQUEST, agreementsList),
    takeLatest(types.ACCOUNT_FETCH_AGREEMENTS_REQUEST, fetchAgreements),
    takeLatest(types.ACCOUNT_FETCH_AGREEMENTS_STATES_REQUEST, fetchAgreementsState),
    takeLatest(types.ACCOUNT_FETCH_MORE_AGREEMENTS_REQUEST, fetchMoreAgreements),
    takeLatest(types.ACCOUNT_TICKET_CREDENTIAL_REQUEST, listCredentialsGroups),
    takeLatest(types.NEW_ACCOUNT_TICKET_REQUEST, accountRequest),
    takeLatest(types.AGREEMENT_AVAILABLE_AMOUNT_REQUEST, agreementAvailableAmountRequest),
    takeLatest(types.AGREEMENT_TAX_REQUEST, agreementTaxRequest),
    takeLatest(types.NEW_AGREEMENT_TICKET_REQUEST, newAgreementRequest),
    takeLatest(types.SIGN_ACCOUNT_TICKET_REQUEST, signAccountTransaction),
    takeLatest(types.ACCOUNT_HISTORICAL_BALANCES_REQUEST, historicalBalancesRequest),
    takeLatest(types.CHANGE_CBU_ALIAS_REQUEST, changeCbuAliasRequest),
    takeLatest(types.DOWNLOAD_MOVEMENT_REQUEST, downloadMovement),
    takeLatest(types.CASH_OUT_PREVIEW_REQUEST, cashOutPreview),
    takeLatest(types.CASH_OUT_SEND_REQUEST, cashOutSend),
    takeLatest(types.DIRECT_DEBIT_UPLOAD_DOCUMENT_REQUEST, directDebitUploadDocument),
    takeLatest(types.DIRECT_DEBIT_DELETE_DOC_REQUEST, directDebitDeleteDocument),
    takeLatest(types.DIRECT_DEBIT_DOWNLOAD_TEMPLATE_REQUEST, downloadDirectDebitTemplate),
    takeLatest(types.DIRECT_DEBIT_SEND_REQUEST, directDebitSendRequest),
    takeLatest(types.DIRECT_DEBIT_LIST_DOWNLOADS_REQUEST, listDirectDebitDownloads),
    takeLatest(types.DIRECT_DEBIT_GET_DOWNLOAD_REQUEST, getDirectDebitDownload),
];

export default sagas;

function* accountGetYearMonth() {
    //const response = yield call(accountsMiddleware.getYear);
    //const response = yield call(accountsMiddleware.getMonth);

    const year = new Date().getFullYear();
    const years = Array.from(new Array(10), (val, index) => {
        const aux = year - index;
        return { label: aux.toString(), value: aux.toString() };
    });

    const months = [
        { value: "all", label: "Todos" },
        { value: "1", label: "Enero" },
        { value: "2", label: "Febrero" },
        { value: "3", label: "Marzo" },
        { value: "4", label: "Abril" },
        { value: "5", label: "Mayo" },
        { value: "6", label: "Junio" },
        { value: "7", label: "Julio" },
        { value: "8", label: "Agosto" },
        { value: "9", label: "Septiembre" },
        { value: "10", label: "Octubre" },
        { value: "11", label: "Noviembre" },
        { value: "12", label: "Diciembre" },
    ];

    yield put({
        type: types.ACCOUNT_GET_YEARS_MONTH_SUMMARY_SUCCESS,
        years,
        months,
    });
}

function* accountDetails({ idSelectedAccount, formikBag }) {
    const filters = yield select(selectors.getFilters);
    const { dateFrom, dateTo } = filters;
    const { startDate, endDate } = normalizeMovementsDates(dateFrom, dateTo);

    const from = yield call(accountsMiddleware.validateDateMiddleware, startDate);
    const to = yield call(accountsMiddleware.validateDateMiddleware, endDate);

    const response = yield call(accountsMiddleware.listMovements, idSelectedAccount, {
        ...filters,
        dateFrom: from.data.data.dateWorkingDay.split("T")[0],
        dateTo: to.data.data.dateWorkingDay.split("T")[0],
    });

    if (response) {
        if (response.type === "W" && formikBag) {
            formikBag.setErrors(adjustIdFieldErrors(response.data.data));
        } else if (response.status === 200) {
            const showAlert = response.data?.data?.showAlert || false;

            if (showAlert === true) {
                yield put(
                    notificationActions.showNotification(
                        i18n.get(
                            "movements.front.max",
                            "Tenés muchos movimientos, para mejor experiencia de usuario solo visualizarás algunos por pantalla pero podrás ver todos desde la opción de descarga",
                        ),
                        "warning",
                        ["account/details"],
                    ),
                );
            }

            yield put({
                type: types.ACCOUNT_DETAILS_SUCCESS,
                totalCount: response.data.length,
                ...response.data,
                showAlert,
            });
        }
    }
    if (formikBag) {
        formikBag.setSubmitting(false);
    }
}

function* accountRead({ idAccount, getPendingBalance }) {
    const response = yield call(accountsMiddleware.readAccount, idAccount, getPendingBalance);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_READ_SUCCESS,
            account: response.data.data ? response.data.data.account : response.data,
        });
    }
}

function* accountReadQr({ idAccount }) {
    const response = yield call(accountsMiddleware.readQr, idAccount);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_READ_QR_SUCCESS,
            qrCode: response.data.data ? response.data.data.qrCode : response.data,
        });
    }
}

function* agreementsList({ idAccount, date }) {
    const response = yield call(accountsMiddleware.agreements, idAccount, date);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_AGREEMENTS_SUCCESS,
            ...response.data.data,
        });
    }
}

function* downloadStatement({ idStatement }) {
    const response = yield call(accountsMiddleware.downloadStatement, idStatement);

    if (response && response.status === 200) {
        const { base64_extract } = response.data.data;

        downloadPdf("extract", base64_extract);

        yield put({
            type: types.ACCOUNT_DOWNLOAD_STATEMENT_SUCCESS,
        });
    }
}

function* editMovementNote({ accountId, movementId, note }) {
    const response = yield call(accountsMiddleware.editMovementNote, accountId, movementId, note);

    if (response && response.status === 200) {
        const confirmationMessage = i18n.get("accounts.movement.detail.noteSaved");

        yield put(notificationActions.showNotification(confirmationMessage, "success", ["movementDetail"]));
    } else {
        const errorMessage = i18n.get("accounts.movement.detail.noteUnsaved");

        yield put(notificationActions.showNotification(errorMessage, "error", ["movementDetail"]));
    }
}

function* fetchAgreements({ idAccount }) {
    const response = yield call(accountsMiddleware.agreements, idAccount);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_FETCH_MOVEMENTS_SUCCESS,
            ...unifyListParams(response),
        });
    }
}

function* fetchAgreementsState({ idAccount, accountState }) {
    // const response = yield call(accountsMiddleware.listAgreements, accountId, filters);

    yield put({
        type: types.ACCOUNT_FETCH_AGREEMENTS_STATES_SUCCESS,
        data: [
            {
                idAccount: idAccount,
                idStatement: "100",
                note: "transaccion",
                state: accountState,
            },
        ],
    });
}

function* fetchMoreAgreements({ idAccount }) {
    const response = yield call(accountsMiddleware.agreements, idAccount);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_FETCH_MORE_AGREEMENTSS_SUCCESS,
            ...unifyListParams(response),
        });
    }
}

function* fetchMovements({ accountId, filters }) {
    const { dateFrom, dateTo } = filters;
    const { startDate, endDate } = normalizeMovementsDates(dateFrom, dateTo);

    const from = yield call(accountsMiddleware.validateDateMiddleware, startDate);
    const to = yield call(accountsMiddleware.validateDateMiddleware, endDate);

    const response = yield call(accountsMiddleware.listMovements, accountId, {
        ...filters,
        dateFrom: from.data.data.dateWorkingDay.split("T")[0],
        dateTo: to.data.data.dateWorkingDay.split("T")[0],
    });

    if (response && response.status === 200) {
        const showAlert = response.data?.data?.showAlert || false;
        yield put(
            notificationActions.showNotification(
                i18n.get(
                    "movements.front.max",
                    "Tenés muchos movimientos, para mejor experiencia de usuario solo visualizarás algunos por pantalla pero podrás ver todos desde la opción de descarga",
                ),
                "warning",
                ["account/details"],
            ),
        );

        yield put({
            type: types.ACCOUNT_FETCH_MOVEMENTS_SUCCESS,
            ...unifyListParams(response),
            showAlert,
        });
    }
}

function* fetchMovementsState({ accountId, accountState }) {
    yield put({
        type: types.ACCOUNT_FETCH_MOVEMENTS_STATES_SUCCESS,
        data: [
            {
                idAccount: accountId,
                idStatement: "100",
                note: "transaccion",
                state: accountState,
            },
        ],
    });
}

function* fetchMoreMovements({ accountId, filters }) {
    const { dateFrom, dateTo } = filters;
    const { startDate, endDate } = normalizeMovementsDates(dateFrom, dateTo);

    const from = yield call(accountsMiddleware.validateDateMiddleware, startDate);
    const to = yield call(accountsMiddleware.validateDateMiddleware, endDate);

    const response = yield call(accountsMiddleware.listMovements, accountId, {
        ...filters,
        dateFrom: from.data.data.dateWorkingDay.split("T")[0],
        dateTo: to.data.data.dateWorkingDay.split("T")[0],
    });

    if (response && response.status === 200) {
        const showAlert = response.data?.data?.showAlert || false;
        yield put(
            notificationActions.showNotification(
                i18n.get(
                    "movements.front.max",
                    "Tenés muchos movimientos, para una mejor experiencia de usuario solo visualizarás algunos por pantalla pero podrás ver todos desde la opción de descarga",
                ),
                "warning",
                ["account/details"],
            ),
        );

        yield put({
            type: types.ACCOUNT_FETCH_MORE_MOVEMENTS_SUCCESS,
            ...unifyListParams(response),
            showAlert,
        });
    }
}

function* historicalBalancesRequest({ idAccount, date }) {
    const response = yield call(accountsMiddleware.historicalBalances, idAccount, date);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_HISTORICAL_BALANCES_SUCCESS,
            ...response.data.data,
            date,
            idAccount,
        });
    }
}

function* listAccountsRequest() {
    const { pathname } = yield select(formSelectors.getPrevRoute);
    const response = yield call(accountsMiddleware.listAccounts);
    const isAccountPage = pathname.includes("accounts");
    const isAgreementPage = pathname.includes("agreements");

    if (response && response.data.code === "API612W") {
        yield put(replace("/desktop"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["desktop"]));
        yield put({ type: types.LIST_ACCOUNTS_FAILURE });
    } else if (response && response.status === 200) {
        yield put({
            type: types.LIST_ACCOUNTS_SUCCESS,
            ...response.data.data,
        });
    }
}

function* listAllAccountsRequest() {
    const { pathname } = yield select(formSelectors.getPrevRoute);
    const response = yield call(accountsMiddleware.listAllAccounts);

    if (response && response.data.code === "API612W") {
        yield put(replace("/desktop"));
        yield put(notificationActions.showNotification(response.data.message, "error", ["desktop"]));
        yield put({ type: types.LIST_ACCOUNTS_FAILURE });
    } else if (response && response.status === 200) {
        yield put({
            type: types.LIST_ACCOUNTS_SUCCESS,
            ...response.data.data,
        });
    }
}

function* listAccountsCbuRequest() {
    const { pathname } = yield select(formSelectors.getPrevRoute);
    const response = yield call(accountsMiddleware.listAccountsCbu);
    const isAccountPage = pathname.includes("accounts");

    if (response && response.status === 200) {
        const { accounts } = response.data.data;

        if (accounts.length === 1 && isAccountPage) {
            yield put(
                replace({
                    pathname: `/accounts/${accounts[0].productId}`,
                    state: { transition: NO_TRANSITION },
                }),
            );
        } else {
            yield put({
                type: types.LIST_ACCOUNTS_CBU_SUCCESS,
                ...response.data.data,
            });
        }
    }
}

function* listStatements({ year, month, accountId }) {
    const response = yield call(accountsMiddleware.listStatements, year, month, accountId);
    if (response && response.status === 200) {
        yield put({
            type: types.LIST_ACCOUNT_STATEMENTS_SUCCESS,
            statementLines: { ...response.data.data },
        });

        if (response.data.code === "BAK600W") {
            yield put(notificationActions.showNotification(response.data.message, "error", ["account/details"]));
        }
    }
}

function* downloadHistoricalBalances({ idProduct, date, format }) {
    const filters = yield select(selectors.getFilters);
    const { type, data } = yield call(accountsMiddleware.downloadHistoricalBalances, idProduct, date, format);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_HISTORICAL_BALANCES_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["account/details"]),
        );
    } else {
        const { content, fileName } = data.data;

        if (format === "pdf") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }

        yield put({ type: types.DOWNLOAD_HISTORICAL_BALANCES_SUCCESS });
    }
}

function* downloadMovements({ idAccount, format }) {
    const filters = yield select(selectors.getFilters);
    const { type, data } = yield call(accountsMiddleware.downloadMovements, idAccount, filters, format);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_MOVEMENTS_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["account/details"]),
        );
    }

    if (type === "I") {
        const { content, fileName, sendMail } = data?.data;
        if (content && fileName) {
            if (format === "pdf") {
                downloadPdf(fileName, content);
            } else {
                downloadXls(fileName, content);
            }
        }

        if (sendMail === true) {
            yield put(
                notificationActions.showNotification(
                    i18n.get(
                        "movements.download.max",
                        "La lista de movimientos será enviando a su correo. Revise dentro de unos minutos",
                    ),
                    "warning",
                    ["account/details"],
                ),
            );
        }

        yield put({ type: types.DOWNLOAD_MOVEMENTS_SUCCESS });
    }
}

function* downloadPendingMovements({ idAccount, dateFrom, dateTo, format }) {
    const { type, data } = yield call(accountsMiddleware.downloadPendingMovements, idAccount, dateFrom, dateTo, format);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_PENDING_MOVEMENTS_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["account/details"]),
        );
    } else {
        const { content, fileName } = data.data;

        if (format === "pdf") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }

        yield put({ type: types.DOWNLOAD_PENDING_MOVEMENTS_SUCCESS });
    }
}

function* downloadAccounts({ format }) {
    const { type, data } = yield call(accountsMiddleware.downloadAccounts, format);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_ACCOUNTS_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["account/details"]),
        );
    } else {
        const { content, fileName } = data.data;

        if (format === "pdf") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }

        yield put({ type: types.DOWNLOAD_ACCOUNTS_SUCCESS });
    }
}

function* listCredentialsGroups() {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: true, idActivityToRead: "request.account.send" };
    const response = yield call(accountsMiddleware.listCredentialsGroups, params);

    if (response && response.status === 200) {
        yield put({
            type: types.ACCOUNT_TICKET_CREDENTIAL_SUCCESS,
            newAccountRequiredCredentials: response.data.data?.groups[0]?.credentials,
        });
    }
}

function* agreementAvailableAmountRequest() {
    const response = yield call(accountsMiddleware.agreementAvailableAmountRequest);
    if (response && response.status === 200) {
        yield put({
            type: types.AGREEMENT_AVAILABLE_AMOUNT_SUCCESS,
            agreementAvailableAmount: response.data.data.calificacion,
        });
    }
}

function* agreementTaxRequest({ currency, deadline, amount }) {
    const response = yield call(accountsMiddleware.agreementTaxRequest, {
        currency,
        amount: amount,
        expirationDate: deadline,
    });
    if (response && response.status === 200) {
        yield put({
            type: types.AGREEMENT_TAX_SUCCESS,
            agreementTax: response?.data?.data?.rate,
        });
    }
}

function* newAgreementRequest({ newAgreement, formikBag, credentialType }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const { currency, amount: amountRequired } = newAgreement;
    const amount = { currency, quantity: amountRequired };

    try {
        const params = { idUser, ...newAgreement, amount };
        const response = yield call(accountsMiddleware.newAgreementRequest, params);

        const { code, data } = response.data;

        const ticketStates = {
            COR020W: "INVALID_CREDENTIAL",
            COR023I: "PENDING",
            COR000I: "FINISHED",
            API560W: "OMA_API_INTERNAL_ERROR",
        };

        if (response.type === "W") {
            const { message: defaultMessageError = i18n.get("global.unexpectedError") } = response.data;

            const messageErrorBackend = code === "COR020W" ? credentialsErrorMessage(data) : data.error;

            yield put(
                notificationActions.showNotification(messageErrorBackend || defaultMessageError, "error", [
                    "/accounts/agreements/summaryForm",
                ]),
            );
        } else if (code === "COR000I") {
            yield put(
                notificationActions.showNotification(i18n.get("activities.request.agreement.finished"), "success", [
                    "/accounts/agreements/successTransaction/",
                ]),
            );
        }

        yield put({
            type: types.NEW_AGREEMENT_TICKET_SUCCESS,
            newAgreementTicket: {
                status: ticketStates[response.data.code],
                ...response.data,
            },
        });
    } catch (error) {
        const _error = {
            ...error,
            data: {
                ...error.data,
                code: error?.data?.code || "COR20W",
                message: i18n.get("global.unexpectedError"),
            },
        };
        yield call(handleError, _error);
    } finally {
        if (formikBag) {
            formikBag.setSubmitting(false);
        }
    }
}

function* accountRequest({ newAccountData }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = { idUser, active: true, ...newAccountData };
    const response = yield call(accountsMiddleware.accountRequest, params);

    if (response && response.status === 200) {
        const ticketStates = {
            COR020W: "INVALID_CREDENTIAL",
            COR023I: "PENDING", // Signs
            API515I: "PENDING", // Backoffice
            COR000I: "FINISHED",
        };

        yield put({
            type: types.NEW_ACCOUNT_TICKET_SUCCESS,
            newAccountTicket: {
                status: ticketStates[response.data.code],
                ...response.data,
                backLinkTo: "/accounts/requestForm",
            },
        });
    }
}

function* signAccountTransaction({ signParams }) {
    const { userId: idUser } = sessionSelectors.getUser(store.getState());
    const params = {
        idUser,
        active: true,
        idForm: "accountOpening",
        idActivity: "request.account.send",
        ...signParams,
    };
    const signResponse = yield call(accountsMiddleware.signAccountTransaction, params);

    if (signResponse && signResponse.status === 200) {
        const { code, ...data } = signResponse.data;
        const ticketStates = {
            COR020W: "INVALID_CREDENTIAL",
            COR023I: "PENDING",
            COR000I: "FINISHED",
        };

        yield put({
            type: types.SIGN_ACCOUNT_TICKET_SUCCESS,
            newAccountTicket: {
                status: ticketStates[code],
                ...data,
            },
        });
    }
}

function* changeCbuAliasRequest({ idAccount, cbu, newAlias, password, formikBag, toggleSidebar }) {
    try {
        const response = yield call(accountsMiddleware.changeCbuAlias, idAccount, cbu, newAlias, password);
        if (response.type === "W") {
            const { code } = response.data;
            const invalidPassword = "COR020W";
            if (code === invalidPassword) {
                yield put(
                    notificationActions.showNotification(i18n.get("preferences.password.password.incorrect"), "error", [
                        "account/details",
                    ]),
                );
            } else {
                yield put(
                    notificationActions.showNotification(response.data.data.message, "error", ["account/details"]),
                );
                yield put({ type: types.CHANGE_CBU_ALIAS_FAILURE });
            }
        } else if (response.status === 200) {
            const { cbuAlias } = response.data.data;
            yield put({ type: types.CHANGE_CBU_ALIAS_SUCCESS, cbuAlias });
            yield put(
                notificationActions.showNotification(i18n.get("accounts.cbu.newAlias.success"), "success", [
                    "account/details",
                ]),
            );
        }
        if (formikBag) {
            formikBag.setSubmitting(false);
            toggleSidebar(true);
        }
    } finally {
        yield put({ type: types.CHANGE_CBU_ALIAS_FAILURE });
    }
}

function* downloadMovement({ movement, format }) {
    //const filters = yield select(selectors.getFilters);
    const { type, data } = yield call(accountsMiddleware.downloadMovement, movement, format);

    if (type === "W") {
        yield put({ type: types.DOWNLOAD_MOVEMENT_FAILURE });
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["account/details"]),
        );
    } else {
        const { content, fileName } = data.data;

        if (format === "pdf") {
            downloadPdf(fileName, content);
        } else {
            downloadXls(fileName, content);
        }

        yield put({ type: types.DOWNLOAD_MOVEMENT_SUCCESS });
    }
}

function* cashOutPreview({ params }) {
    const response = yield call(accountsMiddleware.cashOutPreview, params);

    if (response && response.status === 200) {
        const { code } = response.data;

        if (code === "COR020W") {
            yield put(notificationActions.showNotification(response.data.data.odeData, "error", ["cashOut"]));
            yield put({ type: types.CASH_OUT_PREVIEW_FAILURE });
        } else {
            yield put({
                type: types.CASH_OUT_PREVIEW_SUCCESS,
            });
        }
    } else {
        yield put(notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["cashOut"]));
        yield put({ type: types.CASH_OUT_PREVIEW_FAILURE });
    }
}

function* cashOutSend({ params, formikBag }) {
    try {
        const { odeData, _otp, amount } = params;

        const idTransaction = params?.idTransaction;
        const response = yield call(accountsMiddleware.cashOutSend, { odeData, _otp, idTransaction, amount });

        if (response && response.status === 200) {
            const { code } = response.data;
            const ticketStates = {
                COR020W: "INVALID_CREDENTIAL",
                COR023I: "PENDING",
                COR000I: "FINISHED",
            };

            yield put({
                type: types.CASH_OUT_SEND_SUCCESS,
                cashOutSendStatus: ticketStates[code],
            });

            if (code === "COR020W") {
                formikBag.setErrors({
                    credential: i18n.get("validate.secondFactor.invalid"),
                });
                formikBag.setSubmitting(false);
                return;
            }

            if (code === "COR000I") {
                yield put(
                    notificationActions.showNotification(i18n.get("cash.out.tiket.succes"), "success", [
                        "cash.out.trasaction",
                    ]),
                );
            }
            if (code === "COR023I") {
                yield put(
                    notificationActions.showNotification(i18n.get("cash.out.tiket.pending"), "success", [
                        "cash.out.trasaction",
                    ]),
                );
            }

            if (response && code !== "COR020W") {
                yield put(replace(`/cashOut/transaction/${response.data.idTransaction}`));
            }
        } else {
            yield put({ type: types.CASH_OUT_SEND_FAILURE });
            yield put(notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", ["cashOut"]));
        }
    } catch (error) {
        // El CBU esta en la lista negra
        if (error?.data?.code === "BAK618E") {
            yield put(push("/cashOut/error"));
            return;
        } else if (error?.data?.code !== "BAK618E") {
            yield put(replace(`/cashOut/transaction/${error.data.idTransaction}`));
            return;
        } else throw error;
    }
}

function* directDebitUploadDocument({ documentToUpload }) {
    const response = yield call(accountsMiddleware.directDebitDocumentUpload, documentToUpload);
    if (response && response.status === 200) {
        if (response.type === "W") {
            yield put(
                notificationActions.showNotification(response.data.data.errorMsg, "error", ["DirectDebitNotification"]),
            );
            yield put({
                type: types.DIRECT_DEBIT_UPLOAD_DOCUMENT_FAILURE,
                documentToUploadRequest: response?.data?.data?.errorMsg,
                documentCode: documentToUpload.uploaderRequestId,
            });
            yield put({
                type: types.DIRECT_DEBIT_SET_UPLOAD_ERROR_REQUEST,
                externalUploadError: response?.data?.data?.errorMsg + "|" + Date.now(),
            });
        } else {
            yield put({
                type: types.DIRECT_DEBIT_UPLOAD_DOCUMENT_SUCCESS,
                documentToUploadRequest: response.data?.data,
                documentCode: documentToUpload.uploaderRequestId,
                fileId: response?.data?.data?.fileId,
            });
        }
    } else {
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", [
                "DirectDebitNotification",
            ]),
        );
        yield put({ type: types.DIRECT_DEBIT_UPLOAD_DOCUMENT_FAILURE });
    }
}

function* directDebitDeleteDocument({ fileId }) {
    const params = {
        fileId,
    };
    const response = yield call(accountsMiddleware.directDebitDocumentDelete, params);

    if (response && response.status === 200) {
        if (response.type === "W") {
            yield put(
                notificationActions.showNotification(response.data.data.errorMsg, "error", ["DirectDebitNotification"]),
            );
            yield put({ type: types.DIRECT_DEBIT_DELETE_DOC_FAILURE });
        } else {
            yield put({
                type: types.DIRECT_DEBIT_DELETE_DOC_SUCCESS,
                documentToUploadRequest: response.data?.data,
                documentCode: "1",
            });
        }
    } else {
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", [
                "DirectDebitNotification",
            ]),
        );
        yield put({ type: types.DIRECT_DEBIT_DELETE_DOC_FAILURE });
    }
}

function* downloadDirectDebitTemplate() {
    const response = yield call(accountsMiddleware.downloadTemplate, {
        idTemplate: "TEMPLATE_DIRECT_DEBIT",
        nameFile: "DDT2025031430123456789001",
        format: "txt",
    });
    if (response.type === "W") {
        yield put(notificationActions.showNotification(response.data.message, "error", ["DirectDebitNotification"]));
    } else {
        yield put(
            notificationActions.showNotification(i18n.get("global.successDownload"), "success", [
                "DirectDebitNotification",
            ]),
        );

        const { fileName, content } = response.data.data;
        try {
            downloadTxt(fileName, content);
        } catch (error) {
            console.log(error);
            // error al descargar archivo
        }
    }
}

function* directDebitSendRequest({ params, formikBag }) {
    const { _otp, idTransaction, fileName, fileId } = params;

    try {
        const response = yield call(accountsMiddleware.directDebitSend, {
            documentName: fileName,
            fileId,
            _otp,
            idTransaction,
        });
        if (response && response.status === 200) {
            if (response.type === "W") {
                if (response.data?.data?.otp) {
                    formikBag.setErrors({
                        credential: i18n.get("validate.secondFactor.invalid"),
                    });
                    formikBag.setSubmitting(false);
                    return;
                }

                yield put(
                    notificationActions.showNotification(response.data.data.errorMsg, "error", ["DirectDebitConfirm"]),
                );
                yield put({
                    type: types.DIRECT_DEBIT_SEND_FAILURE,
                });

                formikBag.setSubmitting(false);
                return;
            }

            yield put({
                type: types.DIRECT_DEBIT_SEND_SUCCESS,
            });

            yield put({
                type: types.DIRECT_DEBIT_CLEAN_REQUEST,
            });

            yield put(push(`/directDebit/transaction/${response.data.idTransaction}`, { isConfirm: true }));
        } else {
            yield put({ type: types.DIRECT_DEBIT_SEND_FAILURE });
            yield put(
                notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", [
                    "DirectDebitConfirm",
                ]),
            );
        }
    } catch (error) {
        yield put({ type: types.DIRECT_DEBIT_SEND_FAILURE });
        yield put(push(`/directDebit/transaction/${error.data.idTransaction}`, { isConfirm: true }));
    }
}

function* listDirectDebitDownloads({ params }) {
    try {
        const { cuit } = params;
        const response = yield call(accountsMiddleware.directDebitListDownloads, { cuit });

        if (response.type === "W") {
            yield put(
                notificationActions.showNotification(response.data.message, "error", ["DirectDebitNotification"]),
            );
        } else {
            const { downloadsList } = response.data.data;
            yield put({
                type: types.DIRECT_DEBIT_LIST_DOWNLOADS_SUCCESS,
                directDebitDownloadsList: downloadsList,
            });
        }
    } catch (error) {
        yield put(
            notificationActions.showNotification(i18n.get("global.unexpectedError"), "error", [
                "DirectDebitNotification",
            ]),
        );
        yield put({
            type: types.DIRECT_DEBIT_LIST_DOWNLOADS_FAILURE,
        });
    }
}

function* getDirectDebitDownload({ params }) {
    try {
        const { fileToDownload } = params;
        const response = yield call(accountsMiddleware.directDebitGetDownload, { fileToDownload: fileToDownload });

        if (response.type === "W") {
            yield put(
                notificationActions.showNotification(i18n.get("directDebit.downloadFile.error"), "error", [
                    "DirectDebitNotification",
                ]),
            );
            yield put({
                type: types.DIRECT_DEBIT_GET_DOWNLOAD_FAILURE,
            });
        } else {
            const { fileContent } = response.data.data;
            yield put({
                type: types.DIRECT_DEBIT_GET_DOWNLOAD_SUCCESS,
            });

            try {
                downloadTxt(fileToDownload, fileContent);
            } catch (error) {
                console.log(error);
                // error al descargar archivo
            }
        }
    } catch (error) {
        yield put(
            notificationActions.showNotification(i18n.get("directDebit.downloadFile.error"), "error", [
                "DirectDebitNotification",
            ]),
        );
        yield put({
            type: types.DIRECT_DEBIT_GET_DOWNLOAD_FAILURE,
        });
    }
}
